// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @actions
const sendExtractsViaMailActions = require('actions/contactCenter/sendExtractsViaMail/sendExtractsViaMail');
const profileActions = require('actions/profile');

// @components
const SendExtractsViaMailView = require('components/contactCenter/sendExtractsViaMail/sendExtractsViaMailView');

class SendExtractsViaMailContainer extends React.Component {
    render() {
        return <SendExtractsViaMailView {...this.props} />;
    }
}

SendExtractsViaMailContainer.propTypes = {
    immSendExtractsViaMail: PropTypes.object.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    showCancelModal: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    immDocuments: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immPrecontractualMail: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    immSendExtractsViaMail: state.sendExtractsViaMail,
    immDocuments: state.documents,
    immProfile: state.profile,
    immPrecontractualMail: state.preContractualMail
});

module.exports.constructor = SendExtractsViaMailContainer;
module.exports.SendExtractsViaMailContainer = connect(
    mapStateToProps,
    {
        setVisibleStep: sendExtractsViaMailActions.setVisibleStep,
        validateStep: sendExtractsViaMailActions.validateStep,
        showCancelModal: sendExtractsViaMailActions.showCancelModal,
        reset: sendExtractsViaMailActions.reset,
        confirmSendExtractsViaMail: sendExtractsViaMailActions.confirmSendExtractsViaMail,
        requestProfile: profileActions.requestProfile,
    }
)(SendExtractsViaMailContainer);
